import React from 'react';

import { appRoutes, DateFormatPatterns, RouterEntitiesId } from '@clearverify/constants';
import type { Nullable } from '@clearverify/types';
import { formatDate, getDateTimeInTimezone } from '@clearverify/utils';

import { VerificationRequest } from 'src/api';
import { Link } from 'src/components/common';
import { useCurrentUser } from 'src/hooks/user';
import { buildUrl } from 'src/utils/router';

export type VerificationRequestLinkProps = {
  verificationRequest?: Nullable<Pick<VerificationRequest, 'createdAt' | 'inboxItemId'>>;
};

export const VerificationRequestLink: React.FC<VerificationRequestLinkProps> = ({
  verificationRequest,
}) => {
  const { timezone } = useCurrentUser();

  if (!verificationRequest) {
    return null;
  }

  const { createdAt, inboxItemId } = verificationRequest;

  const linkUrl = buildUrl(appRoutes.inbox.inboxItem, {
    [RouterEntitiesId.inboxItem]: inboxItemId,
  });

  const createdAtUserTimezone = getDateTimeInTimezone(createdAt, timezone)?.toISO();

  return (
    <Link to={linkUrl}>
      Verification Report (created{' '}
      {formatDate(createdAtUserTimezone, DateFormatPatterns.shortDateWithSlash)})
    </Link>
  );
};
